<template>
  <b-row>
    <div class="col-md-12">
      <b-alert v-if="tokenExpiryState" show variant="dark-warning">
        <i class="ion ion-md-warning mr-2"></i> Tu sesión caducará en <strong>{{timeToExpire}}</strong>, puedes realizar logout de forma manual para autenticarte de nuevo, o bien, tu sesión se cerrará de forma automática.
      </b-alert>
    </div>
  </b-row>
</template>
<style type="text/css">
  .alert-fixed {
    position: fixed;
    bottom:0;
    z-index: 5000;
  }
</style>
<script>
import moment from 'moment'

export default {
  name: 'ExpireAlert',
  data: () => ({
    timeToExpire: null,
    timer: null
  }),
  computed: {
    tokenExpiryState () {
      return this.$store.state.auth.tokenExpiry
    },
    tokenExp () {
      return this.$store.state.auth.tokenExp
    }
  },
  watch: {
    tokenExpiryState: function () {
      if (this.tokenExp && this.tokenExpiryState) {
        this.timer = setInterval(this.updateTimeToExpire, 1000)
      }
    }
  },
  methods: {
    updateTimeToExpire () {
      if (this.tokenExp) {
        const now = moment()
        const milisToexpire = this.tokenExp.diff(now)
        const duration = moment.duration(milisToexpire)
        const time = (duration.hours() === 0 ? '' : duration.hours() + ':') + (duration.minutes() === 0 ? '' : duration.minutes() + ':') + this.pad(duration.seconds(), 2)
        // this.timeToExpire = this.round(milisToexpire / 1000)
        this.timeToExpire = time
      }
    }
  },
  created () {
    if (this.tokenExp && this.tokenExpiryState) {
      this.timer = setInterval(this.updateTimeToExpire, 1000)
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}

</script>
